import * as React from "react";

export default function Line({ props, children }) {
  return (
    <>
      <div className="line"></div>
    </>
  );
}
